import Swal from "sweetalert2";

const showCustomAlert = (type, message, navigate, redirectTo, onConfirm) => {
  return new Promise((resolve) => {
    const theme = JSON.parse(localStorage.getItem("theme")) || {};

    let title = "🎉 Success!";
    let bgColor = theme.BtnPriBgCol || "#101610";
    let textColor = theme.BtnPriTxtCol || "#ffffff";
    let confirmBtnColor = theme.BtnPriBgCol || "#dbf169";
    let cancelBtnColor = theme.BtnSecBgCol || "#6c757d";
    let confirmTextColor = theme.BtnPriTxtCol || "#ffffff";
    let cancelTextColor = theme.BtnSecTxtCol || "#ffffff";

    if (type === "error") {
      title = "❌ Warning !";
      bgColor = theme.BtnPriBgCol || "#d9534f";
      textColor = theme.BtnPriTxtCol || "#ffffff";
    } else if (type === "confirm") {
      title = "⚠️ Are you sure?";
      bgColor = theme.BtnPriBgCol || "#f0ad4e";
      textColor = theme.BtnPriTxtCol || "#ffffff";
    }

    if (type === "confirm") {
      Swal.fire({
        width: "400px",
        padding: "0",
        background: "transparent",
        showConfirmButton: false,
        showCancelButton: false,

        html: `
          <div style="width: 100%; height: auto; max-height: 250px; 
            border-radius: 12px; box-shadow: 0 6px 15px rgba(0,0,0,0.2); overflow: hidden; position: relative; 
            background:#18221f; text-align: center;color: #fff;">
            
            <div style="padding: 20px; border-radius: 12px 12px 0 0; text-align: center;
              background: #101610; color: #fff; font-weight: bold;">
              <h1 style="margin: 0; font-size: 20px; color:#FFF!important;">${title}</h1>
            </div>
            
            <div style="padding: 20px; color: #ffffffff";">
              <p style="font-size: 16px; margin: 5px 0;">${message}</p>
            </div>

            <div style="display: flex; justify-content: center; padding: 10px;">
              <button id="confirmBtn" style="background: #dbf169; color: #000; 
                border: none; padding: 10px 20px; margin: 5px; border-radius: 8px; cursor: pointer; font-size: 14px;">
                Yes
              </button>
              <button id="cancelBtn" style="background: ${cancelBtnColor}; color: ${cancelTextColor}; 
                border: none; padding: 10px 20px; margin: 5px; border-radius: 8px; cursor: pointer; font-size: 14px;">
                No
              </button>
            </div>
          </div>
        `,
        didRender: () => {
          document.getElementById("confirmBtn").addEventListener("click", () => {
            Swal.close();
            resolve({ isConfirmed: true }); // Confirmed
          });
          document.getElementById("cancelBtn").addEventListener("click", () => {
            Swal.close();
            resolve({ isConfirmed: false }); // Cancelled
          });
        },
      });
    } else {
      Swal.fire({
        width: "400px",
        padding: "0",
        background: "transparent",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,

        didClose: () => {
          if (redirectTo === "back") {
            window.history.back();
          } else if (navigate && redirectTo) {
            navigate(redirectTo);
          }
          resolve({ isConfirmed: true });
        },
        html: `
          <div style="width: 100%; height: auto; max-height: 250px; 
            border-radius: 12px; box-shadow: 0 6px 15px rgba(0,0,0,0.2); overflow: hidden; position: relative; 
            background: #101610 ; text-align: center;">
            
            <div style="padding: 20px; border-radius: 12px 12px 0 0; text-align: center;
            color: #fff; font-weight: bold;">
              <h1 style="margin: 0; font-size: 20px; color:#fff !important;">${title}</h1>
            </div>
            
            <div style="padding: 20px; color: #fff;">
              <p style="font-size: 16px; margin: 5px 0;">${message}</p>
            </div>
          </div>
        `,
      });
    }
  });
};

export default showCustomAlert;
